import { extendTheme } from "@chakra-ui/react";
import { BLUE_COLOR, DARK_BLUE_COLOR, DARK_YELLOW_COLOR, YELLOW_COLOR } from "../const";

const ButtonStyle = {
  baseStyle: {
    color: "black",
    borderRadius: "20px",
  },
  variants: {
    yellow: {
      bg: YELLOW_COLOR,
      _hover: {
        bg: DARK_YELLOW_COLOR,
        _disabled: {
          bg: YELLOW_COLOR,
        },
      },
      _active: {
        bg: DARK_YELLOW_COLOR,
      },
    },
    blue: {
      bg: BLUE_COLOR,
      _hover: {
        bg: DARK_BLUE_COLOR,
        _disabled: {
          bg: BLUE_COLOR,
        },
      },
      _active: {
        bg: DARK_BLUE_COLOR,
      },
    },
  },
};

const HeaderStyle = {
  baseStyle: {
    lineHeight: "base",
    fontWeight: "medium",
  },
  sizes: {
    lg: {
      fontSize: "2xl",
    },
    md: {
      fontSize: "xl",
    },
    sm: {
      fontSize: "lg2",
    },
  },
  defaultProps: {
    size: "md",
  },
};

export const customTheme = extendTheme({
  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    "lg2": "20px",
    xl: "24px",
    "2xl": "28px",
    "3xl": "32px",
  },
  components: {
    Button: ButtonStyle,
    Heading: HeaderStyle,
  },
});
